(() => {
  const norm = (s) => (s || '').toString().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

  document.querySelectorAll('[data-eb-faq]').forEach((root) => {
    const items = [...root.querySelectorAll('[data-eb-faq-group]')];
    const navWrap = root.querySelector('.eb-faq-accordion__nav');
    let navs = [...root.querySelectorAll('[data-eb-faq-cat]')];
    const search = root.querySelector('[data-eb-faq-search]');
    const clearBtn = root.querySelector('[data-eb-faq-clear]');
    const resultLine = root.querySelector('[data-eb-faq-result]');
    const empty = root.querySelector('[data-eb-faq-empty]');
    const emptyTerm = root.querySelector('[data-eb-faq-empty-term]');

    if (!items.length) return;

    const ALL = '__all__';
    let activeCat = ALL;
    let term = '';
    const showCounts = !!root.querySelector('[data-eb-faq-cat] .eb-faq-accordion__nav-count');

    // Pre-index searchable text per item
    items.forEach((item) => {
      const q = item.querySelector('.eb-faq-item__summary')?.textContent || '';
      const a = item.querySelector('.eb-faq-item__answer-inner')?.textContent || '';
      item._faqText = norm(q + ' ' + a);
    });

    // Build any missing category buttons from the rendered FAQ items. This keeps
    // the theme editor in sync when block category settings change live.
    if (navWrap) {
      const existing = new Set(navs.map((nav) => nav.dataset.ebFaqCat));
      const categories = [];
      items.forEach((item) => {
        const group = item.dataset.ebFaqGroup;
        if (!group || group === ALL || existing.has(group) || categories.some((cat) => cat.group === group)) return;
        categories.push({ group, label: item.dataset.ebFaqLabel || group });
      });

      categories.forEach((cat) => {
        const button = document.createElement('button');
        button.className = 'eb-faq-accordion__nav-item';
        button.type = 'button';
        button.dataset.ebFaqCat = cat.group;
        button.setAttribute('aria-pressed', 'false');

        const label = document.createElement('span');
        label.textContent = cat.label;
        button.appendChild(label);

        if (showCounts) {
          const count = document.createElement('span');
          count.className = 'eb-faq-accordion__nav-count';
          count.setAttribute('aria-hidden', 'true');
          button.appendChild(count);
        }

        navWrap.appendChild(button);
      });

      navs = [...root.querySelectorAll('[data-eb-faq-cat]')];
    }

    // Total counts per category
    const counts = {};
    let total = 0;
    items.forEach((item) => {
      const group = item.dataset.ebFaqGroup;
      counts[group] = (counts[group] || 0) + 1;
      total += 1;
    });
    counts[ALL] = total;

    navs.forEach((nav) => {
      const cat = nav.dataset.ebFaqCat;
      if (cat !== ALL && !counts[cat]) nav.remove();
    });
    navs = [...root.querySelectorAll('[data-eb-faq-cat]')];

    const setCount = (cat, n) => {
      navs.forEach((nav) => {
        if (nav.dataset.ebFaqCat !== cat) return;
        const c = nav.querySelector('.eb-faq-accordion__nav-count');
        if (c) c.textContent = n;
      });
    };

    const apply = () => {
      let visible = 0;

      items.forEach((item) => {
        const inCat = activeCat === ALL || item.dataset.ebFaqGroup === activeCat;
        const inTerm = term === '' || item._faqText.indexOf(term) !== -1;
        const show = inCat && inTerm;
        item.hidden = !show;
        if (show) visible += 1;
        // Collapse hidden items so they don't stay open off-screen
        if (!show && item.open) item.open = false;
      });

      // Update nav counts to reflect the active search term
      navs.forEach((nav) => {
        const cat = nav.dataset.ebFaqCat;
        let n = 0;
        items.forEach((item) => {
          const inCat = cat === ALL || item.dataset.ebFaqGroup === cat;
          const inTerm = term === '' || item._faqText.indexOf(term) !== -1;
          if (inCat && inTerm) n += 1;
        });
        setCount(cat, n);
        nav.classList.toggle('is-empty', n === 0);
      });

      // Active nav state
      navs.forEach((nav) => {
        const on = nav.dataset.ebFaqCat === activeCat;
        nav.classList.toggle('is-active', on);
        nav.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // Empty + result line
      if (empty) empty.hidden = visible !== 0;
      if (emptyTerm && search) emptyTerm.textContent = term ? `\u201C${search.value.trim()}\u201D` : '';
      if (resultLine) {
        if (term) {
          resultLine.hidden = false;
          resultLine.textContent = resultLine.dataset.template
            ? resultLine.dataset.template.replace('{{ count }}', visible)
            : `${visible}`;
        } else {
          resultLine.hidden = true;
        }
      }
      if (clearBtn) clearBtn.hidden = term === '';
    };

    navs.forEach((nav) => {
      nav.addEventListener('click', () => {
        activeCat = nav.dataset.ebFaqCat;
        apply();
      });
    });

    if (search) {
      let t;
      search.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          term = norm(search.value.trim());
          apply();
        }, 90);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (search) search.value = '';
        term = '';
        apply();
        if (search) search.focus();
      });
    }

    apply();
  });
})();
